import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.keys";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.number.constructor";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapMutations, mapState } from 'vuex';
import iotFetchMixin from './iotFetchMixin';
import AddressLatLongMixin from '@/components/core/addressLatLongMixin';
import get from 'lodash/get';
export default {
  name: 'CoreDtwinDuplicateIothubOrComplete',
  mixins: [iotFetchMixin, AddressLatLongMixin],
  props: {
    orgTwin: {
      type: Object,
      required: true
    },
    orgTwinStates: {
      type: Array,
      required: true
    },
    twinCopiesData: {
      type: Array,
      required: true
    },
    statePickerMode: {
      type: String,
      required: true
    },
    errornousParentId: {
      type: Number,
      required: true
    },
    bridgeConfigs: {
      type: Array,
      required: true
    },
    globalParentTwin: {
      type: Object,
      required: true
    },
    // eslint-disable-next-line vue/require-prop-types
    globalParentId: {
      // is either false or a number
      required: true
    },
    loadingStates: {
      type: Boolean,
      required: true
    },
    pickableStates: {
      type: Array,
      required: true
    },
    metaInfoToggles: {
      type: Object,
      required: true
    }
  },
  data: function data() {
    return {};
  },
  computed: _objectSpread(_objectSpread({}, mapState('app', ['inpOutlined', 'inpFilled', 'image', 'color'])), {}, {
    titlePlaceholder: function titlePlaceholder() {
      return "".concat(this.orgTwin.title, " copy [X]");
    },
    tableFooterProps: function tableFooterProps() {
      return {
        itemsPerPageText: this.$i18n_t('Common.rowsPerPage'),
        itemsPerPageOptions: [5, 10, 20]
      };
    }
  }),
  methods: _objectSpread(_objectSpread({}, mapMutations('app', ['snackbar'])), {}, {
    get: get,
    stateConfigChanged: function stateConfigChanged(index, stateIndex, prefix) {
      this.$refs["".concat(prefix, "_").concat(index, "_state_").concat(stateIndex)][0].saveState();
    },
    twinParentFilter: function twinParentFilter(twin) {
      return !get(twin, 'properties.disabled');
    },
    updateTwinsParents: function updateTwinsParents(parentTwin) {
      var _this = this;

      this.twinCopiesData.forEach(function (twin) {
        if (_this.$refs["twin-finder-".concat(twin.id)]) {
          _this.$refs["twin-finder-".concat(twin.id)].digitalTwin = null;
        }

        twin.parentId = parentTwin.id;
      });
    },
    handleCoordinateChange: function handleCoordinateChange(twin) {
      this.handleParsingCoordinates(twin.coordinates.coordinates);
    }
  })
};